module.exports = __webpack_public_path__ + "img/sacola.39df0467.png";